module.exports = __webpack_public_path__ + "img/hand-wave.78d25e6c.svg";